import request from '@/utils/request'

// 查询平台地址列表
export function listAddress(query) {
  return request({
    url: '/cloudplant/platformAddress/list',
    method: 'get',
    params: query
  })
}

// 新增平台地址
export function addAddress(data) {
  return request({
    url: '/cloudplant/platformAddress/add',
    method: 'post',
    data: data
  })
}

// 修改平台地址
export function updateAddress(data) {
  return request({
    url: '/cloudplant/platformAddress/edit',
    method: 'post',
    data: data
  })
}

// 删除平台地址
export function delAddress(data) {
  return request({
    url: '/cloudplant/platformAddress/delete',
    method: 'post',
    data: data
  })
}
